module.exports = __webpack_public_path__ + "img/Panama.962d59e8.png";